type CurrencyLimited = { currencies: readonly (string | null)[] | null };

/**
 * Magento only returns a widget limited to some currencies while one of them is active
 * (it filters on the content-currency header), so any widget listing currencies is
 * specific to the current one. Slots that show a single widget try these first and
 * fall back to the widgets shown for every currency.
 */
export function splitCurrencySpecific<T extends CurrencyLimited>(
    widgets: readonly (T | null)[] | null | undefined,
): { specific: T[]; generic: T[] } {
    const specific: T[] = [];
    const generic: T[] = [];
    for (const widget of widgets ?? []) {
        if (!widget) continue;
        if (widget.currencies?.length) {
            specific.push(widget);
        } else {
            generic.push(widget);
        }
    }
    return { specific, generic };
}
